<div class="po-row po-mb-1">
    <div class="po-xl-10 po-lg-10 po-md-9 po-sm-12">
        <p class="po-font-title">Pedidos</p>
    </div>
    <div class="po-xl-2 po-lg-2 po-md-2 po-sm-12 po-text-right po-mt-2">
        <po-button p-label="Filtros" p-icon="{{seeFilter ? funnelIconFill : funnelIcon }}"
            (p-click)="onClick()"></po-button>
    </div>
</div>
<app-filter-dropdown *ngIf="seeFilter" (onFilterClick)="getOrders()" (onCleanFilterClick)="cleanFilter()">
    <div class="po-xl-6 po-lg-6 po-md-12 po-sm-12">
        <p>Status</p>
        <po-select name="statusDefault" [ngModel]="itemFilter" [p-options]="statusItens"
            (p-change)="recoverStatusSelected($event)" p-placeholder="Selecione um status">
        </po-select>
    </div>
    <div class="po-xl-6 po-lg-6 po-md-12 po-sm-12">
        <p>Código do pedido</p>
        <po-input (p-change)="setOrderCodeFilter($event)" type="number" p-placeholder="Digite o código do pedido"
            [p-maxlength]="20" [(ngModel)]="orderCodeFilter">
        </po-input>
    </div>
</app-filter-dropdown>
<div class="po-row po-mt-2 po-mb-5" [class.fade-in]="fadeInAnimation">
    <div class="po-row po-flex po-mb-2" style="justify-content: flex-end;">
        <app-scanner
            (scannedData)="onScanOrderCode($event)"
            class="po-xl-12 po-lg-12 po-md-12 po-sm-12 barcode-button">
        </app-scanner>
    </div>
    <div class="po-row po-mb-5">
        <div class="po-mt-1 po-xl-1 po-lg-1 po-md-12 po-sm-12">
            <po-button p-kind="secondary" p-icon="an {{sortAsc ? 'an-sort-ascending': 'an-sort-descending'}}"
                (p-click)="changeSort()" class="po-text-center sort-button"></po-button>
        </div>
    </div>
    <div *ngIf="!nullFilter" class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
        <app-order-header-list [orders]="filteredOrders" (orderSelected)="onOrderSelected($event)" />
    </div>
    <div *ngIf="nullFilter" class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-text-center">
        <p>Nenhum item encontrado</p>
    </div>
</div>

<po-modal #modalBarCodeReader [p-click-out]="false" [p-hide-close]="true" p-title="Leitor Código de barras">
</po-modal>